<template>
  <vs-dialog
  v-model="active"
  @close="closeModal"
  not-close
  :loading="loading"
  class="userProfileModal"
  >    
    <template #header>
      <h4 class="not-margin">
        Réinitialiser votre <b>mot de passe</b>
      </h4>
    </template>

    <form class="con-form" @submit.prevent="submit">

      <vs-input type="email" v-model="fields.code" placeholder="Code indiqué à l'étape précédente">
        <template #icon>
          1
        </template>
      </vs-input>

      <vs-input type="password" v-model="fields.password" placeholder="Mot de passe" autocomplete="new-password">
        <template #icon>
          <i class='bx bxs-lock'></i>
        </template>
      </vs-input>

      <vs-input type="password" v-model="fields.passwordConfirm" placeholder="Confirmation du mot de passe" autocomplete="new-password">
        <template #icon>
          <i class='bx bxs-lock'></i>
        </template>
      </vs-input>

      <vs-alert v-if="errorsSentences.length > 0" :key="errorsCodes.join()">

        <template #title>
          {{ errorsSentences.length >= 2 ? 'Erreurs' : 'Erreur' }} de connexion
        </template>
        
        <ul v-if="errorsSentences.length >= 2" style="margin: 0">
          <li v-for="(sentence, index) in errorsSentences" :key="index">{{ sentence }}</li>
        </ul>

        <span v-else>{{ errorsSentences[0] }} </span>

      </vs-alert>

    </form>

    <template #footer>
      <div class="footer-dialog">
        <vs-button block @click="submit">
          Réinitialiser mon mot de passe
        </vs-button>

        <div class="new">
          Vous avez votre mot de passe ?<a href="#" @click="changeUserModal('login')">Connectez-vous ici</a>
        </div>
      </div>
    </template>
  </vs-dialog>
</template>

<script>
  import { ModalWithUserForm } from '@/mixins/ModalWithUserForm.js'

  export default {
    name: 'PasswordReset',
    mixins: [ModalWithUserForm],
    data() {
      return {
        fields: {
          code: '',
          password: '',
          passwordConfirm: ''
        },
        code: null
      }
    },
    watch: {
      currentOpenedUserModal(newVal) {
        this.active = (newVal === 'passwordreset')
      }
    },
    methods: {
      async submit () {
        // Vérifications des valeurs
        this.errorsCodes = []
        this.checkFields()
        // Envoie de la demande de réinitialisation au serveur
        if (this.errorsCodes.length === 0) {
          this.loading = true
          const error = await this.$store.dispatch('user/reset', { 
            code: this.fields.code,
            password: this.fields.password,
            token: this.$route.query.token
          })
          this.loading = false
          if (typeof error === 'string') {
            this.errorsCodes.push(error)
          } else {
            this.$store.dispatch('notification/success', 'Votre mot de passe a bien été mise à jour')
            this.changeUserModal('login')
            this.$router.push({ query: Object.assign({}, this.$route.query, { modal: undefined, token: undefined }) });
            this.errorsCodes = []
            this.resetFields()
          }
        }
      },
      checkFields() {
        if (this.fields.code === '' || this.fields.password === '' || this.fields.passwordConfirm === '') {
          this.errorsCodes.push('empty_field')
        } else if (this.fields.password !== this.fields.passwordConfirm) {
          this.errorsCodes.push('passwords_dont_match')
        }
      },
      resetFields() {
        this.fields.code = ''
        this.fields.password = ''
        this.fields.passwordConfirm = ''
      }
    }
  }
</script>

<style lang="scss">
.not-margin {
	margin: 0px;
	font-weight: normal;
	padding: 10px;
}

.con-form {
	width: 100%;

  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    a {
      font-size: 0.8rem;
      opacity: 0.7;
      &:hover {
        opacity: 1;
      }
    }
  }

  .vs-checkbox-label {
    font-size: 0.8rem;
  }

  .vs-input-content {
    margin: 10px 0px;
    width: calc(100%);
    .vs-input {
      width: 100% !important;
    }
  }

}

.contentUserModal {
  max-width: 500px; 
  line-height: 1.75;
}
.codeForgotPassword {
  text-align: center; 
  letter-spacing: 5px;
  font-size: 2em;
  color: #F73859;
}

.footer-dialog {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: calc(100%);

  .new {
    margin: 0px;
    margin-top: 20px;
    padding: 0px;
    font-size: 0.7rem;
    a {
      color: getColor('primary') !important;
      margin-left: 6px;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .vs-button {
    margin: 0px;
  }


}
</style>